import { Component, Host, h, Prop, Element } from '@stencil/core';

@Component({
  tag: 'spw-breadcrumb',
  styleUrl: 'spw-breadcrumb.scss',
  shadow: true,
})
export class SpwBreadcrumb {
  /** Permet de limiter le breadcrumb à x éléments visibles */
  maxItems?: number = 9999;
  /** Permet de sélectionner la variante de breadcrumb */
  @Prop() variant: 'multiline' | 'one-line' | 'default' = 'default';
  /** Permet de choisir la surface d'arrière-plan du breadcrumb */
  @Prop() surface?: 'light' | 'dark' = 'light';
  @Element() host: HTMLSpwBreadcrumbElement;

  componentDidLoad() {
    this.updateBreadcrumbVisibility();
  }

  componentDidUpdate() {
    this.updateBreadcrumbVisibility();
  }

  private updateBreadcrumbVisibility() {
    const items = this.host.querySelectorAll('spw-breadcrumb-item');
    const totalItems = items.length;

    items.forEach(item => {
      item.classList.remove('hidden-item', 'collapsed-item');
    });

    if (totalItems > this.maxItems) {
      const visibleAtStart = this.maxItems - 1;

      items.forEach((item, index) => {
        if (index >= visibleAtStart && index < totalItems - 1) {
          if (index === totalItems - 2) {
            item.classList.add('collapsed-item');
          } else {
            item.classList.add('hidden-item');
          }
        }
      });
    }
  }

  render() {
    const elementClass = {
      'spw-breadcrumb': true,
      [`spw-breadcrumb--surface-${this.surface}`]: true,
      [`spw-breadcrumb--${this.variant}`]: true,
    };

    return (
      <Host>
        <nav aria-label="breadcrumb" class={elementClass}>
          <ol class="spw-breadcrumb__list">
            <slot></slot>
          </ol>
        </nav>
      </Host>
    );
  }
}
